import React, { useState, useEffect } from 'react'
import numeral from 'numeral'
import { Mutation, Query } from 'react-apollo'
import { useMutation } from '@apollo/react-hooks'
import moment from 'moment'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  message, Modal, Select, Menu, Button, Checkbox, Upload, Icon, Row, Col, Dropdown, Input as AntInput, Switch,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton, Input, Loading, Button as KSButton,
} from 'konsys-ui'
import Image from '../common/img'
import {
  CANCEL_FUEL_ORDER, LOST_FUEL_ORDER, UPDATE_FUEL_ORDER, RECORD_FUEL_LOG, TOGGLE_PAID_BY_FLEET_CARD,
} from '../../constants/graphql/mutation'
import { GET_QRCODE } from '../../constants/graphql/query'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/filling-order-page/constants'
import { P } from '../../pages/filling-order-page/styled'
import PERMISSION from '../../constants/permissions'
import { getAccessToken, getURL } from '../../utils/local-data-service'
import { checkFloat, toSafeFloat } from '../../utils/util-services'
import { FloatInput } from '../shipping-order-components'
import { isLatedMoreThan60days } from '../../pages/shipping-order-page/util-functions'
import { fuelTypeList } from '../../pages/filling-order-page/detail/component-renderer'
import { colorSelector, textStatusSelector } from '../../pages/shipping-order-page/list/table'
import {
  status as shippingStatus,
} from '../../pages/shipping-order-page/constants'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)} value={value}/>
)

export const mappingValueToTypeText = (value) => {
  const mapped = _.find(fuelTypeList, o => o.value === value)
  return (
    _.isUndefined(mapped) ? 'ไม่ระบุ' : mapped.text
  )
}

export const DropdownSelector = ({
  data, handleChange, typeNameTh, width,
}) => {
  const actualWidth = width || (typeNameTh ? '120px' : '100px')
  return (
    <Select
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width: actualWidth }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
    {
      data.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
    }
    </Select>
  )
}

export const IsPaidByFleetCardToggle = ({
  defaultChecked, id, disabled,
}) => {
  const [doToggle, { loading }] = useMutation(TOGGLE_PAID_BY_FLEET_CARD)
  return (
    <Switch
      disabled={disabled || loading}
      defaultChecked={defaultChecked}
      onChange={(e) => {
        doToggle({
          variables: {
            id,
            isPaidByFleetCard: e,
          },
        }).then((resp) => {
          const response = resp.data.IsPaidByFleetCardFuelOrder
          if (response.success) {
            message.success(response.message)
          } else message.error(response.message)
        })
      }}
    />
  )
}

export const StatusSelector = ({
  handleChange, filter, disabled, mobile,
}) => {
  const arr = mobile ? [
    { value: status.WAITING, text: statusText.WAITING },
    { value: status.PRINTED, text: statusText.PRINTED },
  ] : [
    { value: status.WAITING, text: statusText.WAITING },
    { value: status.EXPIRED, text: statusText.EXPIRED },
    { value: status.PRINTED, text: statusText.PRINTED },
    { value: status.FILLED, text: statusText.FILLED },
    { value: status.BILLED, text: statusText.BILLED },
    { value: status.CANCELLED, text: statusText.CANCELLED },
    { value: status.LOST, text: statusText.LOST },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      style={{ width: 130 }}
      defaultValue="ทั้งหมด"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

const menu = (props, onModalChange) => {
  const filterActions = (fuelStatus) => {
    const arr = [
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_FUEL)}>
        <Link target="_blank" to={`/fill-order/view/${props.original.id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>,
    ]
    console.info(props.original.isSpecial)
    switch (fuelStatus) {
      case status.WAITING:
        return _.concat(arr, [
          <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
            <Link target="_blank" to={`/fill-order/edit/${props.original.id}`}>
              แก้ไข
            </Link>
          </Menu.Item>,
          <Menu.Item key='amount' disabled={!_.includes(window.perms, PERMISSION.RECORD_FILLING_FUEL)}>
            บันทึกการเติมน้ำมัน
          </Menu.Item>,
          <Menu.Item key='qrcode'>
            แสกน QR Code
          </Menu.Item>,
          // <Menu.Item key='lost' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
          //   บันทึกการสูญหาย
          // </Menu.Item>,
          <Menu.Item key='cancel' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
            ยกเลิกบิลน้ำมัน
          </Menu.Item>,
        ])
      case status.EXPIRED:
        return _.concat(arr, [
          <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL) || window.role !== 'SuperAdmin'}>
            <Link target="_blank" to={`/fill-order/edit/${props.original.id}`}>
              แก้ไข
            </Link>
          </Menu.Item>,
          <Menu.Item key='amount' disabled={!_.includes(window.perms, PERMISSION.RECORD_FILLING_FUEL) || isLatedMoreThan60days(fuelStatus, props.original.expiredDate)}>
            บันทึกการเติมน้ำมัน
          </Menu.Item>,
          <Menu.Item key='bill' disabled={!_.includes(window.perms, PERMISSION.ATTACH_BILL_FUEL) || isLatedMoreThan60days(fuelStatus, props.original.expiredDate)}>
            บันทึกบิลน้ำมัน
          </Menu.Item>,
          // <Menu.Item key='lost' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
          //   บันทึกการสูญหาย
          // </Menu.Item>,
          <Menu.Item key='cancel' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
            ยกเลิกบิลน้ำมัน
          </Menu.Item>,
        ])
      case status.PRINTED:
        return _.concat(arr, [
          <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
            <Link target="_blank" to={`/fill-order/edit/${props.original.id}`}>
              แก้ไข
            </Link>
          </Menu.Item>,
          <Menu.Item key='amount' disabled={!_.includes(window.perms, PERMISSION.RECORD_FILLING_FUEL)}>
            บันทึกการเติมน้ำมัน
          </Menu.Item>,
          <Menu.Item key='qrcode'>
            แสกน QR Code
          </Menu.Item>,
          // <Menu.Item key='lost' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
          //   บันทึกการสูญหาย
          // </Menu.Item>,
          <Menu.Item key='cancel' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
            ยกเลิกบิลน้ำมัน
          </Menu.Item>,
        ])
      case status.FILLED:
        return _.concat(arr, [
          <Menu.Item key='edit' disabled={window.role !== 'SuperAdmin'}>
            <Link target="_blank" to={`/fill-order/edit/${props.original.id}`}>
              แก้ไข
            </Link>
          </Menu.Item>,
          <Menu.Item key='bill' disabled={!_.includes(window.perms, PERMISSION.ATTACH_BILL_FUEL)}>
            บันทึกบิลน้ำมัน
          </Menu.Item>,
          // <Menu.Item key='lost' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
          //   บันทึกการสูญหาย
          // </Menu.Item>,
          <Menu.Item key='cancel' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
            ยกเลิกบิลน้ำมัน
          </Menu.Item>,
        ])
        case status.BILLED:
          return _.concat(arr, [
            <Menu.Item key='edit' disabled={window.role !== 'SuperAdmin'}>
              <Link target="_blank" to={`/fill-order/edit/${props.original.id}`}>
                แก้ไข
              </Link>
            </Menu.Item>,
            <Menu.Item key='cancel' disabled={!_.includes(window.perms, PERMISSION.UPDATE_FUEL)}>
              ยกเลิกบิลน้ำมัน
            </Menu.Item>,
          ])
        case status.CANCELLED:
          return _.concat(arr, [
            <Menu.Item key='edit' disabled={
              window.role === 'Route Planner'
              ? !props.original.isSpecial
              : window.role !== 'SuperAdmin'
            }>
              <Link target="_blank" to={`/fill-order/edit/${props.original.id}`}>
                แก้ไข
              </Link>
            </Menu.Item>,
          ])
      default:
        return arr
    }
  }
  return (
    <Div>
      <Menu
        onSelect={e => onModalChange(e.key)}
        selectedKeys={undefined}
      >
        {
          filterActions(props.original.status).map(v => v)
        }
      </Menu>
    </Div>
  )
}

export const ActionSelector = ({ props, refetch }) => {
  const [cancelModal, setCancelModal] = useState(false)
  const [lostModal, setLostModal] = useState(false)
  const [uploadModal, setUploadModal] = useState(false)
  const [qrCodeModal, setQrCodeModal] = useState(false)
  const [recordFillingModal, setRecordFillingModal] = useState(false)

  const onModalChange = (key) => {
    if (key === 'cancel') setCancelModal(true)
    else if (key === 'lost') setLostModal(true)
    else if (key === 'bill') setUploadModal(true)
    else if (key === 'qrcode') setQrCodeModal(true)
    else if (key === 'amount') setRecordFillingModal(true)
  }

  return (
    <Div>
      <Dropdown overlay={menu(props, onModalChange)} trigger='click'>
        <Button>
          ดูรายละเอียด <Icon type="down" />
        </Button>
      </Dropdown>
      <CancelModal id={props.original.id} cancelModal={cancelModal} setCancelModal={setCancelModal} refetch={refetch} info={props.original}/>
      <UploadModal id={props.original.id} uploadModal={uploadModal} setUploadModal={setUploadModal} refetch={refetch} info={props.original}/>
      <RecordFillingModal id={props.original.id} recordFillingModal={recordFillingModal} setRecordFillingModal={setRecordFillingModal} refetch={refetch} info={props.original}/>
      <QrcodeModal id={props.original.id} qrCodeModal={qrCodeModal} setQrCodeModal={setQrCodeModal} info={props.original}/>
      <LostModal id={props.original.id} lostModal={lostModal} setLostModal={setLostModal} refetch={refetch} amount={props.original.totalAmount} info={props.original}/>
    </Div>
  )
}

export const LimitSelectors = ({ limit, setLimit, totalCount }) => {
  const limitList = [5, 10, 30, 50, 100, 300, 500]
  return (
    <Select
      dropdown
      style={{ width: 130 }}
      defaultValue="5"
      value={limit}
      onChange={(e) => {
        if (e > totalCount) {
          message.warning('จำนวนใบเบิกน้ำมันมีน้อยกว่าจำนวนที่เลือก')
          setLimit(totalCount)
        } else {
          setLimit(e)
        }
      }}
    >
      {
        limitList.map(v => <Select.Option key={v} value={v}>{v}</Select.Option>)
      }
    </Select>
  )
}

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, status: fuelStatus, disabled, refetch, volumeNumber,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const download = (id, refetchFunc) => {
    setIsLoading(true)
    window.open(
      `${getURL().FILE_SERVER}/downloadfile/pdf/fuelOrder/${id}?t=${getAccessToken()}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    refetchFunc()
    setIsLoading(false)
  }

  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        margin='0 16px 0 16px'
        text='พิมพ์ใบเบิกน้ำมัน'
        icon='fas fa-print'
        loading={isLoading}
        disabled={isLoading
          || (_.includes(['SuperAdmin', 'Admin'], window.role) ? !_.includes([status.WAITING, status.PRINTED], fuelStatus) : !_.includes([status.WAITING], fuelStatus))
          || !_.includes(window.perms, PERMISSION.PRINT_FUEL)
        }
        onClick={() => download(props.match.params.id, refetch)}
      />
      <KonsysButton
        loading={loading}
        disabled={
          loading
          || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_FUEL))
          || disabled
          || (
            !_.includes([status.WAITING, status.PRINTED], fuelStatus) // false
            && (_.includes([status.EXPIRED, status.FILLED, status.BILLED], fuelStatus) && window.role !== 'SuperAdmin') // true
          )
        }
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/fill-order/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateFuelOrder : data.UpdateFuelOrder

              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/fill-order')
                else window.location = `/fill-order/view/${props.match.params.id}`
              } else message.error(resp.message)
            })
          }
        }}
      />
    </Div>
  )
}

const CancelModal = ({
  id, setCancelModal, cancelModal, refetch, info,
}) => (
    <Mutation
      mutation={CANCEL_FUEL_ORDER}
    >{(doCancelFuelOrder, { loading }) => (
        <Modal
          title="ต้องการยกเลิกบิลน้ำมัน?"
          visible={cancelModal}
          okButtonProps={{
            loading,
          }}
          onCancel={() => setCancelModal(false)}
          onOk={() => doCancelFuelOrder({
            variables: {
              id,
              status: status.CANCELLED,
            },
          }).then((resp) => {
            const response = resp.data.UpdateFuelOrder
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
            setCancelModal(false)
          })}
        >
          <Div display='flex' flexDirection='column'>
            <Div display='flex' flexDirection='row' justifyContent='space-between' margin='0 0 24px 0'>
              <P bold style={{ width: 'fit-content' }}>Ref id: {info.ShippingOrder.id}</P>
              <Div display='flex'>
                <P bold style={{ width: 'fit-content' }} margin='0 16px 0'>เล่มที่: {info.shippingVolume}</P>
                <P bold style={{ width: 'fit-content' }}>เลขที่: {info.shippingNumber}</P>
              </Div>
            </Div>
            <P>คุณไม่สามารถเปลี่ยนสถานะกลับได้หลังจากได้ดำเนินการไปแล้ว</P>
          </Div>
        </Modal>
    )}
    </Mutation>
)

const LostModal = ({
  id, setLostModal, lostModal, refetch, amount, info,
}) => {
  const [checkTotalDeduct, setCheckTotalDeduct] = useState(false)

  const [totalDeduct, setTotalDeduct] = useState(0)
  const [checkNextOrder, setCheckNextOrder] = useState(false)

  return (
    <Mutation
      mutation={LOST_FUEL_ORDER}
    >{(doLostFuelOrder, { loading }) => (
        <Modal
          title="บันทึกการสูญหาย?"
          visible={lostModal}
          onCancel={() => setLostModal(false)}
          okButtonProps={{
            loading,
          }}
          onOk={() => doLostFuelOrder({
            variables: {
              fuelId: parseInt(id, 10),
              totalDeduct: parseInt(totalDeduct, 10),
              nextOrder: checkNextOrder,
            },
          }).then((resp) => {
            const response = resp.data.CreateFuelCompensation
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
            setLostModal(false)
          })}
        >
          <Div display='flex' flexDirection='column'>
            <Div display='flex' flexDirection='row' justifyContent='space-between' margin='0 0 24px 0'>
              <P bold style={{ width: 'fit-content' }}>Ref id: {info.ShippingOrder.id}</P>
              <Div display='flex'>
                <P bold style={{ width: 'fit-content' }} margin='0 16px 0'>เล่มที่: {info.shippingVolume}</P>
                <P bold style={{ width: 'fit-content' }}>เลขที่: {info.shippingNumber}</P>
              </Div>
            </Div>
            <Checkbox
              checked={checkTotalDeduct}
              onChange={() => setCheckTotalDeduct(!checkTotalDeduct)}
            >
              หักเบี้ยเลี้ยง
            </Checkbox>
            <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px 24px'>
              <P style={{ width: 'fit-content' }}>หักออก</P>
              <Input
                disabled={!checkTotalDeduct}
                margin='0 8px'
                onChange={e => setTotalDeduct(e.target.value)}
                onKeyDown={(e) => {
                  if (!checkFloat(e)) {
                    e.preventDefault()
                  }
                }}
                type='number'
                step={0.1}
                min={0}
              />
              <P style={{ width: 'fit-content' }}>บาท</P>
            </Div>
            <Checkbox
              checked={checkNextOrder}
              onChange={() => setCheckNextOrder(!checkNextOrder)}
            >
              หักจากใบเบิกครั้งต่อไป
            </Checkbox>
            <Div margin='0 0 0 24px'>
              <P color={color.error}>หักออก {amount} ลิตร</P>
            </Div>
          </Div>
        </Modal>
    )}
    </Mutation>
  )
}

const UploadModal = ({
  id, setUploadModal, uploadModal, refetch, info,
}) => {
  const [previewImage, setPreviewImage] = useState({})
  const [previewVisible, setPreviewVisible] = useState()
  const [fileList, setFileList] = useState([])
  const [price, setPrice] = useState(!_.isUndefined(info.pricePerLitre) ? info.pricePerLitre : null)

  useEffect(() => { setPrice(!_.isUndefined(info.pricePerLitre) ? info.pricePerLitre : null) }, [info.pricePerLitre])
  useEffect(() => { setFileList(!_.isUndefined(info.files) ? info.files.map(file => ({ ...file, name: file.filename, uid: file.url })) : []) }, [info.files])

  const handleChange = (e) => {
    if (e.file.status === 'removed') {
      if (!e?.file?.url) setFileList(e.fileList)
    } else setFileList([...fileList, { ...e.file, status: 'done' }])
  }
  const handlePreview = async (file) => {
    setPreviewImage(file.url ? file.url : URL.createObjectURL(file.originFileObj))
    setPreviewVisible(true)
  }
  const handleCancel = () => setPreviewVisible(false)
  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">อัพโหลด</div>
    </div>
  )
  const handleOk = (doUpload) => {
    doUpload({
      variables: {
        id: parseInt(id, 10),
        images: fileList.map(v => v.originFileObj || v),
        status: 'BILLED',
        pricePerLitre: price,
      },
    }).then((resp) => {
      const response = resp.data.UpdateFuelOrder
      if (response.success) {
        message.success(response.message)
        refetch()
      } else message.error(response.message)
      setUploadModal(false)
      setFileList([])
      setPreviewImage({})
      setPreviewVisible()
      setPrice(!_.isUndefined(info.pricePerLitre) ? info.pricePerLitre : null)
    })
  }

  const isFileListEmpty = _.isEmpty(fileList)
  const isPriceInvalid = _.isNaN(parseFloat(price))
  const allowedStatuses = info.isSpecial
    ? [shippingStatus.CANCELLED, shippingStatus.DELIVERED, shippingStatus.BILLED, shippingStatus.EXPIRED, shippingStatus.ASSIGNED]
    : [shippingStatus.CANCELLED, shippingStatus.DELIVERED, shippingStatus.BILLED, shippingStatus.EXPIRED]
  const isStatusInvalid = !_.includes(allowedStatuses, info.ShippingOrder.status)
  const isDisabled = isFileListEmpty || isPriceInvalid || isStatusInvalid

  return (
    <Mutation
      mutation={UPDATE_FUEL_ORDER}
    >{(doUpload, { loading }) => (
      <Modal
        title="อัพโหลดบิลน้ำมัน"
        visible={uploadModal}
        onCancel={() => {
          setUploadModal(false)
          setFileList([])
          setPreviewImage({})
          setPreviewVisible()
        }}
        onOk={() => handleOk(doUpload)}
        destroyOnClose={true}
        footer={[
          <Button key="cancel" onClick={() => setUploadModal(false)}>
            ยกเลิก
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={isDisabled}
            loading={loading}
            onClick={() => handleOk(doUpload)}
          >
            อัพโหลด
          </Button>,
        ]}
      >
        <Div display='flex' flexDirection='column'>
          <Div display='flex' flexDirection='row' justifyContent='space-between' margin='0 0 16px 0'>
            <P bold style={{ width: 'fit-content' }}>Ref id: {info.ShippingOrder.id}</P>
            <Div display='flex'>
              <P bold style={{ width: 'fit-content' }} margin='0 16px 0'>เล่มที่: {info.shippingVolume}</P>
              <P bold style={{ width: 'fit-content' }}>เลขที่: {info.shippingNumber}</P>
            </Div>
          </Div>
          <Div margin='0 0 24px 0'>
            <P bold>ชื่อสถานี: {info.Gasstation.name}</P>
            <Row type='flex' gutter={16} align='middle'>
              <Col span={8}><P bold>ปริมาณน้ำมันที่เติม</P></Col>
              <Col span={8}><P bold>ราคาน้ำมัน (ต่อลิตร)</P></Col>
              <Col span={8}><P bold>ค่าน้ำมัน</P></Col>
            </Row>
            <Row type='flex' gutter={16} align='middle'>
              <Col span={8}><P>{numeral(info.filledAmount).format('0,0.00')}</P></Col>
              <Col span={8}>
                <FloatInput
                  isFloat={true}
                  data={{
                    defaultValue: !_.isUndefined(info.pricePerLitre) ? info.pricePerLitre : undefined,
                    value: price,
                  }}
                  onChangeHandler={(key, value) => {
                    if (_.isNaN(value) || (value >= 0 && value <= 80)) setPrice(value)
                  }}
                />
              </Col>
              <Col span={8}><P>{numeral(toSafeFloat(price * info.filledAmount)).format('0,0.00')}</P></Col>
            </Row>
          </Div>
          <Div margin='0 0 24px 0'>
            <Row type='flex' gutter={16} align='middle'>
              <Col span={12}><P display='inline'>สถานะใบสั่งบรรทุก</P></Col>
            </Row>
            <Row type='flex' gutter={16} align='middle'>
              <Col span={12}>
                <P display='inline' color={colorSelector(info.ShippingOrder.status)}>{textStatusSelector(info.ShippingOrder.status)}</P>
              </Col>
            </Row>
          </Div>
          <div className="clearfix" style={{ overflowX: 'auto' }}>
            <Upload
              listType="picture-card"
              fileList={fileList}
              onPreview={e => handlePreview(e)}
              onChange={e => handleChange(e)}
              customRequest={() => null}
              multiple
            >
              {uploadButton}
            </Upload>
            <Modal visible={previewVisible} footer={null} onCancel={() => handleCancel()} destroyOnClose={true} >
              <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
          </div>
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

export const QrcodeModal = ({
  id, setQrCodeModal, qrCodeModal, info,
}) => (
  <Modal
    title="แสกน QR code"
    visible={qrCodeModal}
    onCancel={() => setQrCodeModal(false)}
    footer={[
      <Button key="cancel" onClick={() => setQrCodeModal(false)}>
        ปิด
      </Button>,
    ]}
  >
    <Query
      query={GET_QRCODE}
      variables={{ id }}
    >{({ data, loading, error }) => {
      if (loading) return <Loading />
      if (error) return <P>เกิดข้อผิดพลาด</P>
      const imageSrc = data?.getFuelOrderQRCode?.data?.image

      return (
        <Div display='flex' flexDirection='column'>
          <Div display='flex' flexDirection='row' justifyContent='space-between' margin='0 0 24px 0'>
            <P bold style={{ width: 'fit-content' }}>Ref id: {info?.ShippingOrder?.id}</P>
            <Div display='flex'>
              <P bold style={{ width: 'fit-content' }} margin='0 16px 0'>เล่มที่: {info.shippingVolume}</P>
              <P bold style={{ width: 'fit-content' }}>เลขที่: {info.shippingNumber}</P>
            </Div>
          </Div>
          {
            !_.isNil(imageSrc)
              ? <Image src={data.getFuelOrderQRCode.data.image} style={{ display: 'block', margin: 'auto' }}/>
              : <p className='text-base font-bold' style={{ color: color.primaryColor }}>ไม่สามารถสแกนน้ำมันได้ เนื่องจากคนขับยังมีใบสั่งบรรทุกที่เป็นสถานะขึ้นของแล้วอยู่</p>
          }
        </Div>
      )
    }}
    </Query>
  </Modal>
)

export const RecordFillingModal = ({
  id, setRecordFillingModal, recordFillingModal, info, refetch,
}) => {
  const [amount, setAmount] = useState()
  const [remark, setRemark] = useState()
  const [files, setFiles] = useState([])
  const [pricePerLitre, setPricePerLitre] = useState()

  const handleOk = (doUpload) => {
    doUpload({
      variables: {
        fuelId: parseInt(id, 10),
        amount: parseFloat(amount),
        pricePerLitre: parseFloat(pricePerLitre),
        remark,
        files,
      },
    }).then((resp) => {
      const response = resp.data.CreateFuelOrderLog
      if (response.success) {
        message.success(response.message)
        refetch()
      } else message.error(response.message)
      setRecordFillingModal(false)
    })
  }

  return (
    <Mutation
      mutation={RECORD_FUEL_LOG}
    >{(doRecord, { loading }) => (
      <Modal
        title="บันทึกการเติมน้ำมัน"
        visible={recordFillingModal}
        onCancel={() => setRecordFillingModal(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setRecordFillingModal(false)
            }}
          >
            ปิด
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={_.isNaN(amount) || _.isUndefined(amount) || _.isNaN(pricePerLitre) || _.isUndefined(pricePerLitre)}
            loading={loading}
            onClick={() => {
              handleOk(doRecord)
            }}
          >
            บันทึก
          </Button>,
        ]}
      >
        <Div display='flex' flexDirection='column'>
          <Div display='flex' flexDirection='row' justifyContent='space-between' margin='0 0 24px 0'>
            <P bold style={{ width: 'fit-content' }}>Ref id: {info.ShippingOrder.id}</P>
            <Div display='flex'>
              <P bold style={{ width: 'fit-content' }} margin='0 16px 0'>เล่มที่: {info.shippingVolume}</P>
              <P bold style={{ width: 'fit-content' }}>เลขที่: {info.shippingNumber}</P>
            </Div>
          </Div>
          <Row align='flex-start' type='flex' gutter={12}>
            <Col span={6}><P display='inline'>วันหมดอายุ</P></Col>
            <Col span={6}><P display='inline'>ประเภทเชื้อเพลิง</P></Col>
            <Col span={6}><P display='inline'>ปํ้มน้ำมัน</P></Col>
            <Col span={6}><P display='inline'>บริษัท</P></Col>
          </Row>
          <Row align='flex-start' type='flex' gutter={12} style={{ marginBottom: 16 }}>
            <Col span={6}><P display='inline' bold>{!_.isNull(info.expiredDate) ? moment(info.expiredDate).format('DD MM YYYY') : 'ไม่ระบุ'}</P></Col>
            <Col span={6}><P display='inline' bold>{mappingValueToTypeText(info.fuelType)}</P></Col>
            <Col span={6}><P display='inline' bold>{info.Gasstation.name}</P></Col>
            <Col span={6}><P display='inline' bold>{info.Gasstation.company}</P></Col>
          </Row>
          <Row align='flex-start' type='flex' gutter={12}>
            <Col span={6}><P display='inline'>ปริมาณทั้งหมด</P></Col>
            <Col span={6}><P display='inline'>ปริมาณที่เติม</P></Col>
            <Col span={12}><P display='inline'>ปริมาณเหลือที่เบิกได้</P></Col>
          </Row>
          <Row align='flex-start' type='flex' gutter={12} style={{ marginBottom: 16 }}>
            <Col span={6}><P display='inline' bold margin='0 8px 0 0'>{info.totalAmount}</P><P display='inline'>ลิตร</P></Col>
            <Col span={6}>
              <Input
                onChange={(e) => {
                  if (_.isNaN(parseFloat(e.target.value)) || (parseFloat(e.target.value) >= 0)) setAmount(parseFloat(e.target.value))
                }}
                width='70px'
                margin='0 8px 0 0'
                onKeyDown={ (e) => {
                // TODO: TOP create keycode array
                  if (!checkFloat(e)) {
                    e.preventDefault()
                  }
                }}
                value={amount}
                type='number'
                step={0.1}
                min={0}
              /><P display='inline'>ลิตร</P></Col>
            <Col span={12}><P display='inline' bold margin='0 8px 0 0'>{info.availableAmount}</P><P display='inline'>ลิตร</P></Col>
          </Row>
          <Row align='flex-start' type='flex' gutter={12}>
            <Col span={12}><P display='inline'>ราคาน้ำมันต่อลิตร</P></Col>
            <Col span={12}><P display='inline'>สถานะใบสั่งบรรทุก</P></Col>
          </Row>
          <Row align='flex-start' type='flex' gutter={12}>
            <Col span={12}>
              <Input
                type='number'
                onChange={(e) => {
                  if (_.isNaN(parseFloat(e.target.value)) || (parseFloat(e.target.value) >= 0 && parseFloat(e.target.value) <= 80)) setPricePerLitre(parseFloat(e.target.value))
                }}
                width='70px'
                margin='0 8px 0 0'
                min='0'
                value={pricePerLitre}
                step={0.01}
                onKeyDown={e => !checkFloat(e) && e.preventDefault()}
              />
              <P display='inline'>บาทต่อลิตร</P>
            </Col>
            <Col span={12}>
              <P display='inline' color={colorSelector(info.ShippingOrder.status)}>{textStatusSelector(info.ShippingOrder.status)}</P>
            </Col>
          </Row>
          <Row align='flex-start' type='flex' gutter={12}>
            <Col span={24}>
              <P display='block' margin='16px 0 0 0'>หมายเหตุ</P>
              <AntInput.TextArea defaultValue={info.remark} rows={4} style={{ margin: '8px 0 16px' }} onChange={e => setRemark(e.target.value)}/>
            </Col>
            <Col span={24}>
              <Upload
                onChange={e => setFiles(e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
                customRequest={() => null}
                processData={false}
                beforeUpload={() => false}
                multiple={true}
                defaultFileList={info.files && info.files.map(v => ({
                  name: v.filename,
                  url: v.url,
                  uid: v.url,
                }))}
              >
                <KSButton small text='อัพโหลดไฟล์' icon='far fa-file-upload' />
              </Upload>
            </Col>
          </Row>
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}
